import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(utc);
dayjs.extend(isoWeek);

export function aggregateTrades(trades, mode) {
  if (!trades || trades.length === 0) return [];

  if (mode === "raw") {
    return trades.map(t => ({
      period: dayjs.utc(t.trade_date).format("YYYY-MM-DD"),
      trades: 1,
      pnl: Number(t.cash_return || 0),
      wins: t.cash_return > 0 ? 1 : 0,
      winRate: t.cash_return > 0 ? 100 : 0,
      gainLossRatio: t.cash_return > 0 ? t.cash_return / 0.00001 : 0, // tiny value to avoid division by zero
    }));
  }

  const map = {};

  trades.forEach(trade => {
    let key;

    switch (mode) {
      case "day":
        key = dayjs.utc(trade.trade_date).format("YYYY-MM-DD");
        break;
      case "week":
        key = `${dayjs.utc(trade.trade_date).year()}-W${dayjs.utc(trade.trade_date).isoWeek()}`;
        break;
      case "month":
        key = dayjs.utc(trade.trade_date).format("YYYY-MM");
        break;
      case "year":
        key = dayjs.utc(trade.trade_date).format("YYYY");
        break;
      default:
        return;
    }

    if (!map[key]) {
      map[key] = {
        period: key,
        trades: 0,
        pnl: 0,
        wins: 0,
        winPnL: 0,
        lossPnL: 0,
      };
    }

    map[key].trades += 1;
    map[key].pnl += Number(trade.cash_return || 0);

    if (trade.cash_return > 0) {
      map[key].wins += 1;
      map[key].winPnL += Number(trade.cash_return || 0);
    } else if (trade.cash_return < 0) {
      map[key].lossPnL += Math.abs(Number(trade.cash_return || 0));
    }
  });

  return Object.values(map).map(row => {
    const avgWin = row.wins ? row.winPnL / row.wins : 0;
    const losses = row.trades - row.wins;
    const avgLoss = losses ? row.lossPnL / losses : 0;

    return {
      period: row.period,
      trades: row.trades,
      pnl: row.pnl,
      wins: row.wins,
      winRate: row.trades ? (row.wins / row.trades) * 100 : 0,
      gainLossRatio: avgLoss !== 0 ? avgWin / avgLoss : avgWin, // avoid divide by zero
    };
  });

  
}


